import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { GetMessageResponse, MessageService } from "../message.service";
import { Message } from "../message";
import { PortalUserService } from "@aifs-shared/portal/portal-user-service";

@Component({
    selector: 'app-received-message',
    templateUrl: './received-message-preview.component.html',
    styleUrls: ['./received-message-preview.component.scss'],
    imports: [CommonModule],
    standalone: true,
})
export class ReceivedMessagesComponent {
    messageService = inject(MessageService);
    userService = inject(PortalUserService);

    ngOnInit(): void {
        this.userId = this.userService.getUser().userId;

        this.messageService
            .getReceivedMessages()
            .subscribe({
                next: (m: GetMessageResponse) => {
                    this.messages = [];
                    // console.log(`Recd:${JSON.stringify(m, null, 2)}`);
                    if (m.messages) {
                        m.messages.forEach(msg => {
                            this.messages.push(new MessagePreview(msg.id, msg.name, msg.body, msg.date));
                        });
                    }

                },
                error: (error) => {
                    console.error(error);
                }
            }
            );
    }

    getMessageStatus(m: Message): any {
        const ismine = m.sendingUserId === this.userId;
        return { 'mine': ismine, 'theirs': !ismine };
    }

    userId = 0;
    messages: MessagePreview[] = [];
}

export class MessagePreview {
    id: number;
    from: string;
    previewText: string;
    dateSent: string;

    constructor(id: number, from: string, text: string, sent: string) {
        this.id = id;
        this.from = from;
        this.previewText = (text.length > 100 ? text.substring(0, 100) : text);
        this.dateSent = sent;
    }
}